import React from 'react';
import PropTypes from 'prop-types';
import { Translate, withLocalize } from 'react-localize-redux';
import { hasPermission } from "../../store/apiWrapper";
import classnames from 'classnames';

import PortfolioIcon from '../../img/icons/BBiconsPridatDoPortfolia';

import './refButtons.scss';

class AddToPortfolioButton extends React.Component {
    static propTypes = {
        onClick: PropTypes.func,
        key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        hideLabel: PropTypes.bool
    };

    static defaultProps = {
        onClick: undefined,
        key: undefined,
        hideLabel: false
    };

    render() {
        if (hasPermission(null, 'MainMonitoring')) {
            return (
                <div className="ref-button ref-portfolio" title={this.props.translate('Monitoring.Add.AddToPortfolio')} onClick={this.props.onClick}>
                    <PortfolioIcon className='search-result-icon svg-standard-fill' />
                    {!this.props.hideLabel && <span className={classnames('link-functional', {'is-normal': localStorage.locales_url_format === 'normal', 'hide-on-mobile': !this.props.showOnMobile })}><Translate id="Common.AddToPortfolio" /></span>}
                </div>
            );
        }
        return (<div></div>);
    }
}

export default withLocalize(AddToPortfolioButton);